(function () {
  if (window.StellarTestimonials) {
    window.StellarTestimonials.refresh();
    return;
  }
  const selections = new Map();
  const instances = new Map();
  const clamp = (index, count) => Math.max(0, Math.min(count - 1, index));
  const remember = state => {
    if (!state.resizing && !state.swiper.destroyed) selections.set(state.key, clamp(state.swiper.realIndex, state.count));
  };
  const dispose = section => {
    const state = instances.get(section);
    if (!state) return;
    remember(state);
    state.swiper.destroy(true, true);
    section.classList.remove("slider_started");
    instances.delete(section);
  };

  const sources = new Map();
  const safeURL = (value, productOnly = false) => {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (productOnly && (url.origin !== location.origin || !url.pathname.startsWith('/products/'))) return '';
      return productOnly ? url.pathname + url.search + url.hash : url.href;
    } catch (_) { return ''; }
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const watchReviews = section => {
    const box = section.querySelector('.testimonials[data-dynamic-reviews="true"]');
    const source = box?.querySelector('.stellar-review-source');
    if (!source || sources.has(section)) return;
    const state = { observer: null, timer: null, timeout: null, signature: null };
    sources.set(section, state);
    const render = () => {
      if (!section.isConnected) return;
      const seen = new Set();
      const seenNames = new Set();
      const limit = Math.max(1, Math.min(30, Number(box.dataset.reviewLimit) || 6));
      const reviews = [...source.querySelectorAll('.jdgm-card[data-review-id]:not([data-clone-type])')].flatMap(card => {
        const id = card.dataset.reviewId;
        const rating = card.querySelectorAll('.jdgm-stars .jdgm--on').length;
        const body = card.querySelector('.jdgm-text')?.textContent?.trim();
        if (seenNames.size >= limit || !id || seen.has(id) || rating < 4 || rating > 5 || !body) return [];
        const author = card.querySelector('.jdgm-reviewer-name')?.textContent?.trim() || '';
        const nameKey = author.replace(/\s+/g, ' ').toLowerCase();
        // Presentation-only name filtering; this does not establish customer identity.
        if (!nameKey || /^(anonymous|anonymous reviewer|anonymous customer|guest)$/.test(nameKey) || seenNames.has(nameKey)) return [];
        seen.add(id);
        seenNames.add(nameKey);
        const product = card.querySelector('.jdgm-product-name a');
        const image = card.querySelector('img');
        return [{ id, rating, body, author,
          title: product?.textContent?.trim() || '', href: safeURL(product?.getAttribute('href') || '', true),
          image: safeURL(image?.getAttribute('src') || '') }];
      });
      const signature = JSON.stringify(reviews);
      if (signature === state.signature) return;
      state.signature = signature;
      dispose(section);
      const wrapper = box.querySelector('.testimonials__item-box');
      const fragment = document.createDocumentFragment();
      for (const review of reviews) {
        const slide = element('div', 'testimonials__item-block swiper-slide color-' + box.dataset.colorScheme + ' background');
        slide.dataset.reviewId = review.id;
        const content = element('div', 'testimonials__text-item');
        const header = element('div', 'testimonials__header');
        if (review.image) {
          const picture = element(review.href ? 'a' : 'div', 'testimonials__author-img');
          if (review.href) { picture.href = review.href; picture.tabIndex = -1; picture.setAttribute('aria-hidden', 'true'); }
          const image = element('img', '');
          image.src = review.image.split('?')[0] === 'https://cdn.shopify.com/s/files/1/0863/0956/8825/files/ST40WH_-_zoom.png'
            ? 'https://cdn.shopify.com/s/files/1/0863/0956/8825/files/2602_-_ST40WH_Zoom.png?v=1773023682&width=288'
            : review.image; image.alt = ''; image.loading = 'lazy'; image.width = 72; image.height = 72;
          picture.append(image); header.append(picture);
        }
        const details = element('div', 'testimonial-details');
        if (review.title) {
          const heading = element('h3', 'testimonials__slide-title');
          if (review.href) { const link = element('a', '', review.title); link.href = review.href; heading.append(link); }
          else heading.textContent = review.title;
          details.append(heading);
        }
        const stars = element('div', 'testimonials__slide-stars');
        stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
        const symbols = element('span', '', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
        symbols.setAttribute('aria-hidden', 'true');
        stars.append(symbols, element('span', 'icon-star__count', review.rating.toFixed(1)));
        details.append(stars); header.append(details); content.append(header);
        const body = element('div', 'testimonials__desc richtext__content');
        body.append(element('p', '', review.body)); content.append(body);
        const author = element('div', 'testimonials__author-text');
        author.append(element('div', 'testimonials__author-name extra_small-font', review.author));
        content.append(author); slide.append(content); fragment.append(slide);
      }
      wrapper.replaceChildren(fragment);
      box.dataset.reviewsReady = String(reviews.length > 0);
      if (reviews.length) { clearTimeout(state.timeout); section.hidden = false; refresh(); }
    };
    state.observer = new MutationObserver(() => { clearTimeout(state.timer); state.timer = setTimeout(render, 100); });
    state.observer.observe(source, { childList: true, subtree: true, characterData: true });
    state.timeout = setTimeout(() => {
      if (box.dataset.reviewsReady !== 'true') section.hidden = true;
    }, 15000);
    render();
  };
  const releaseSource = section => {
    const state = sources.get(section);
    if (!state) return;
    state.observer.disconnect(); clearTimeout(state.timer); clearTimeout(state.timeout); sources.delete(section);
  };

  const refresh = () => {
    for (const section of sources.keys()) if (!section.isConnected) releaseSource(section);
    for (const section of instances.keys()) if (!section.isConnected) dispose(section);
    document.querySelectorAll(".testimonials-section").forEach(section => {
      watchReviews(section);
      if (instances.has(section) || typeof Swiper === "undefined") return;
      const box = section.querySelector(".testimonials");
      const slider = section.querySelector(".testimonials__slider");
      if (!box || !slider) return;
      const count = slider.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
      if (!count) return;
      const key = box.dataset.id || section.id || section;
      const initial = clamp(selections.has(key) ? selections.get(key) : (window.innerWidth >= 990 ? 3 : (box.dataset.dynamicReviews === "true" ? 0 : Math.floor((count - 1) / 2))), count);
      const autoplay = box.dataset.autoplay === "true" && count > 1;
      const state = { key, count, resizing: false, swiper: null };
      const swiper = new Swiper(slider, {
        effect: "slide",
        speed: Number(box.dataset.speed) * 1000,
        initialSlide: initial,
        slidesPerView: Math.min(count, 1.1),
        spaceBetween: 16,
        centeredSlides: true,
        breakpoints: {
          576: { slidesPerView: Math.min(count, 2), spaceBetween: 20 },
          990: { slidesPerView: Math.min(count, 3), spaceBetween: 40 }
        },
        autoHeight: false,
        roundLengths: true,
        loop: autoplay,
        loopAdditionalSlides: autoplay ? 30 : 0,
        rewind: !autoplay && count > 1,
        watchOverflow: count === 1,
        allowTouchMove: count > 1,
        keyboard: true,
        navigation: {
          nextEl: section.querySelector(".swiper-button-next"),
          prevEl: section.querySelector(".swiper-button-prev")
        },
        pagination: { el: section.querySelector(".swiper-pagination"), clickable: true },
        autoplay: autoplay ? {
          delay: Number(box.dataset.delay) * 1000,
          pauseOnMouseEnter: box.dataset.stopAutoplay === "true",
          disableOnInteraction: false
        } : false
      });
      state.swiper = swiper;
      instances.set(section, state);
      section.classList.add("slider_started");
      selections.set(key, initial);
      const syncNavigation = () => {
        const wraps = swiper.params.loop || swiper.params.rewind;
        for (const direction of ["prev", "next"]) {
          const button = section.querySelector(".swiper-button-" + direction);
          if (!button) continue;
          const atEdge = direction === "prev" ? swiper.isBeginning : swiper.isEnd;
          const disabled = count < 2 || !swiper.enabled || swiper.isLocked || (!wraps && atEdge);
          button.disabled = !!disabled;
          button.setAttribute("aria-disabled", String(!!disabled));
          button.setAttribute("tabindex", disabled ? "-1" : "0");
        }
      };
      swiper.on("slideChange", () => remember(state));
      swiper.on("beforeResize", () => {
        remember(state);
        state.resizing = true;
      });
      swiper.on("resize", () => {
        const target = clamp(selections.get(key), count);
        if (swiper.params.loop) swiper.slideToLoop(target, 0, false);
        else swiper.slideTo(target, 0, false);
        state.resizing = false;
        syncNavigation();
      });
      swiper.on("breakpoint update slideChange lock unlock", syncNavigation);
      syncNavigation();
    });
  };
  window.StellarTestimonials = { refresh };
  const start = () => {
    refresh();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.matches?.(".testimonials-section") || node.querySelector?.(".testimonials-section"))
      ))) refresh();
    }).observe(document.body, { childList: true, subtree: true });
  };
  document.addEventListener("shopify:section:unload", event => {
    if (event.target.matches(".testimonials-section")) { dispose(event.target); releaseSource(event.target); }
    event.target.querySelectorAll(".testimonials-section").forEach(section => { dispose(section); releaseSource(section); });
  });
  document.addEventListener("shopify:section:load", refresh);
  window.addEventListener("load", refresh, { once: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
